(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  /*
    <hero-slider>: Swiper carousel with responsive, on-demand video slides.
    Shopify doesn't render Liquid in this tag, so options come from data-* attributes.
    Connect/disconnect replaces the old shopify:section:load/unload handling.
  */
  if (!customElements.get('hero-slider')) {
    const desktop = matchMedia('(min-width: 1024px)'); // keep in sync with the CSS
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

    // swiper.js is a deferred <script> that runs after this bundle. If it isn't ready yet,
    // DOMContentLoaded fires once every deferred script has run.
    const swiperReady = () =>
      window.Swiper
        ? Promise.resolve()
        : new Promise((resolve) => addEventListener('DOMContentLoaded', resolve, { once: true }));

    class HeroSlider extends HTMLElement {
      #swiper = null;

      // A video only plays while at least half of it is visible.
      #videoObserver = new IntersectionObserver(
        (entries) => {
          for (const { target: video, isIntersecting } of entries) {
            if (isIntersecting) {
              video.muted = true; // slides cloned by Swiper's loop mode can lose the muted state
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          }
        },
        { threshold: 0.5 }
      );

      connectedCallback() {
        desktop.addEventListener('change', this.#syncVideos);
        this.#syncVideos();
        swiperReady().then(() => {
          if (this.isConnected && !this.#swiper) this.#initSwiper();
        });
      }

      disconnectedCallback() {
        desktop.removeEventListener('change', this.#syncVideos);
        this.#videoObserver.disconnect();
        this.#swiper?.destroy(true, true);
        this.#swiper = null;
      }

      // Picks the desktop or mobile file (either one if only one is set) and
      // re-observes each video so playback restarts after a source change.
      #syncVideos = () => {
        for (const video of this.querySelectorAll('video')) {
          const { srcDesktop, srcMobile } = video.dataset;
          const src = desktop.matches ? srcDesktop || srcMobile : srcMobile || srcDesktop;
          if (src && video.getAttribute('src') !== src) video.src = src;

          this.#videoObserver.unobserve(video);
          this.#videoObserver.observe(video);
        }
      };

      #initSwiper() {
        const { Autoplay, Pagination, A11y } = window.Swiper;
        const pagination = this.querySelector('.swiper-pagination');
        const hasManySlides = this.querySelectorAll('.swiper-slide').length > 1;

        const options = {
          modules: [Autoplay, Pagination, A11y].filter(Boolean),
          loop: hasManySlides,
          allowTouchMove: hasManySlides,
          touchStartPreventDefault: false,
          a11y: { enabled: true },
        };

        if (pagination) {
          options.pagination = { el: pagination, clickable: true };
        }
        if (hasManySlides && !reducedMotion.matches) {
          options.autoplay = {
            delay: Number(this.dataset.autoplayDelay) || 5000,
            disableOnInteraction: false,
          };
        }

        this.#swiper = new window.Swiper(this, options);
        this.#syncVideos(); // loop mode just cloned the slides, so observe the clones too
      }
    }

    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
